
import { getDefaultTrackingDataOptions, TrackingDataOptions, TrackingDataQueryParams } from 'app/lib/types/TrackingDataOptions';
import AppEvents from 'lib/AppEvents';
import Constants from 'lib/Constants';
import { CampaignDataFilter, EnsureCampaignDataOptions, getDefaultEnsureCampaignDataOptions } from 'lib/data/models/CampaignObjects';
import EventService from 'services/EventService';
import IDbOrCacheStore from 'stores/IDbOrCacheStore';
import { getAccountOrThrow } from 'utils/adaya/AdayaUtils';
import { getLogger } from 'utils/logging';
import ProviderService from './ProviderService';

const { log, warn } = getLogger('AccountDataService', { color: 'yellow', enabled: false });


class AccountDataService {

    private store: IDbOrCacheStore;
    //private dayStore: IDbOrCacheStore;

    constructor() {
        this.store = new IDbOrCacheStore('ACCOUNT_');
        EventService.subscribe([AppEvents.LOGIN, AppEvents.LOGOUT], this.clearData);
    }

    getDailyCampaignData = async (filter: CampaignDataFilter, opts?: EnsureCampaignDataOptions) => {
        try {
            opts = getDefaultEnsureCampaignDataOptions(opts); // ensure defaults
            log('getDailyCampaignData', filter, opts);
            if (!filter.account) throw "Must supply a filter.account to getDailyCampaignData.";
            if (!filter.timeRange) throw "Must supply a filter.timeRange to getDailyCampaignData.";
            return await ProviderService.getDailyCampaignData(filter.account, filter, opts);
        } catch (e) {
            throw e;
        }
    }

    getDailyTrackingData = async (account, query: TrackingDataQueryParams, opts?: TrackingDataOptions) => {
        try {
            opts = getDefaultTrackingDataOptions(opts); // ensure defaults
            log('getDailyTrackingData', query, opts);
            if (!query.account) throw "Must supply an account to getDailyTrackingData query.";
            if (!query.timeRange) throw "Must supply a timeRange to getDailyTrackingData query.";
            if (!query.groupBy) throw "Must supply a groupBy parameter to getDailyTrackingData.";
            return await ProviderService.getDailyTrackingData(query.account, query, opts);
        } catch (e) {
            throw e;
        }
    }

    deleteProviderData = async (from: string, to?: string, providers?: Array<ProviderNames>, localOnly = false) => {
        const account = getAccountOrThrow();
        return await ProviderService.deleteProviderDailyData(account, from, to, providers, localOnly);
    }


    ////////////////////////////////////////////////////////////////
    // OLD METHODS: MAY BE DEPRECATED OR REMOVED SOON:

    private _getCacheKey(prefix, accountId, dateRange) {
        return `${prefix}__${accountId}__${dateRange.start_date}__${dateRange.end_date}`;
    }

    // public async getAccountDataByCampaign(accountId, dateRange, useCache = true, dataId = '') {
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             let cacheKey = this._getCacheKey(dataId || 'account-data-by-campaign', accountId, dateRange);
    //             let data;

    //             if (useCache) {
    //                 data = await this.store.get(cacheKey);
    //                 if (data) return resolve(data);
    //             }

    //             const fetchData = async () => {
    //                 try {
    //                     log('Fetching getAccountDataByCampaign ...', dataId);
    //                     return await ensureRequest(async () => {
    //                         try {
    //                             return await ApiService.get(`/account-data/${accountId}/campaign`, {
    //                                 params: { from: dateRange.start_date, to: dateRange.end_date, dataId: cacheKey }
    //                             });
    //                         } catch (e) {
    //                             throw e;
    //                         }
    //                     });
    //                 } catch (e) {
    //                     throw e;
    //                 }
    //             }

    //             let r = await handlePolledRequest(fetchData);
    //             log('getAccountDataByCampaign response:', r)

    //             if (r?.success && r?.data) {
    //                 data = r.data;
    //                 await this.store.set(cacheKey, data);
    //             }

    //             return resolve(data);
    //         } catch (e) {
    //             return reject(e);
    //         }
    //     });
    // }

    public async setCampaignList(campaignList) {
        await this.store.set(Constants.ACCOUNT_CAMPAIGN_LIST, campaignList);
    }

    public clearData = async () => {
        if (this.store) {
            await this.store.clear();
        }
    }

}

export default new AccountDataService();